import React, { useState, useEffect } from "react";
import { Row, Col, FormGroup, FormLabel, FormControl } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDays } from "@fortawesome/free-solid-svg-icons";

interface Dt {
  id?: any;
  formData: any;
  setFormData: any;
  handleChange: any;
  handleBlur: any;
  errors: any
}

const DateForm: React.FC<Dt> = ({ id, formData, setFormData, handleChange, handleBlur, errors }) => {

  const formatDate = (dateString: any) => {
    if (!dateString) return ""; // Evita erro se a data for undefined ou vazia
    const [day, month, year] = dateString.split("/");
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
   
      const today = new Date();
      const dtEmissao = today.toLocaleDateString('pt-BR'); // formato yyyy-mm-dd
      const dtEntrega = new Date(today);
      dtEntrega.setDate(today.getDate() + 15); // adiciona 15 dias
      return setFormData({
        data_emissao: formatDate(dtEmissao),
        previsao_entrega: formatDate(dtEntrega.toLocaleDateString('pt-BR')), // formato yyyy-mm-dd
      });
    
  }, [id]);

  return (
    <Row>
      <div className="d-flex align-items-center gap-2 justify-content-start mt-4">
        <FontAwesomeIcon icon={faCalendarDays} className="fa-xl mb-2" />
        <h4>Informações sobre Datas</h4>
      </div>
      <Col className="col-lg-6 col-md-6 col-12">
        <FormGroup>
          <FormLabel>Data de Emissão</FormLabel>
          <FormControl
            type="date"
            id="data_emissao"
            value={formData.data_emissao}
            onBlur={handleBlur}
            onChange={handleChange}
            isInvalid={!!errors.data_emissao}
            disabled={!!id}
          />
          <FormControl.Feedback type="invalid">{`Insira uma Data de Emissão`}</FormControl.Feedback>
        </FormGroup>
      </Col>
      <Col className="col-lg-6 col-md-6 col-12">
        <FormGroup>
          <FormLabel>Data de Entrega (previsão)</FormLabel>
          <FormControl
            type="date"
            id="previsao_entrega"
            value={formData.previsao_entrega}
            onBlur={handleBlur}
            onChange={handleChange}
            isInvalid={!!errors.previsao_entrega}
          />
          <FormControl.Feedback type="invalid">{`Insira uma previsão de Entrega`}</FormControl.Feedback>
        </FormGroup>
      </Col>
    </Row>
  );
}

export default DateForm;
